<div class="mat-container">
    <h4 mat-dialog-title>No Internet Connection</h4>
    <div mat-dialog-content>
    <p>You are currently offline. Please check your internet connection.</p>
    </div>
    <div mat-dialog-actions>
    </div>
</div>